var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNitrox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 42,
    viewBox: "0 0 20 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2B2B2B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.147 41H6.856C3.626 41 1 38.379 1 35.156V11.314c0-3.222 2.626-5.843 5.856-5.843h6.288c3.23 0 5.856 2.62 5.856 5.843v23.842C19.003 38.38 16.374 41 13.147 41zM6.856 6.846a4.479 4.479 0 0 0-4.478 4.468v23.842a4.479 4.479 0 0 0 4.478 4.469h6.288a4.479 4.479 0 0 0 4.478-4.469V11.314a4.479 4.479 0 0 0-4.478-4.468H6.856z",
    stroke: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.314 31.799H1.689A.687.687 0 0 1 1 31.111V15.36c0-.38.307-.687.689-.687H18.31c.382 0 .689.306.689.687v15.752a.684.684 0 0 1-.686.688zM2.378 30.424h15.244V16.047H2.378v14.377zM11.747 6.846h-3.49a.687.687 0 0 1-.69-.688V.755c0-.38.307-.687.69-.687h3.492c.382 0 .69.306.69.687v5.403a.693.693 0 0 1-.692.688zM8.945 5.47h2.116V1.443H8.945v4.028z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitrox);
export default __webpack_public_path__ + "static/media/nitrox.58df49c28bf9dcb8d563ab962c463f6d.svg";
export { ForwardRef as ReactComponent };